<template>
  <layout-main-inner title="库存管理">
    <el-radio-group slot="append"
                    style="margin-left: 10px;"
                    v-model="config.ownerRange"
                    size="mini"
                    @change="onTypeChange">
      <el-radio-button :label="1">企业库存</el-radio-button>
      <el-radio-button :label="0">客户库存</el-radio-button>
    </el-radio-group>
    <layout-card-wrap hasHeaderSlot
                      v-loading="loading">
      <template slot="form">
        <owner-select v-model="config.ownerId"
                      v-if="config.ownerRange === 0" />
        <el-input placeholder="请输入产品名称"
                  v-model="config.productName"
                  style="margin-left: 10px;width: 220px">
        </el-input>
        <!-- <product-select v-model="config.productId" /> -->
        <el-button type="primary"
                   style="margin-left: 10px;"
                   @click="handleCurrentChange(1)">查询</el-button>
        <el-button type="primary"
                   @click="downloadinventorys">下载</el-button>
      </template>
      <el-table border
                v-loading="loading"
                :data="list">
        <el-table-column label="客户名称"
                         v-if="config.ownerRange === 0"
                         prop="ownerName"
                         min-width="160"></el-table-column>
        <el-table-column label="产品名称"
                         prop="productName"
                         min-width="200"></el-table-column>
        <el-table-column label="产品备注"
                         min-width="200"
                         prop="productNameRemark"></el-table-column>
        <el-table-column label="冻结库存"
                         min-width="100"
                         prop="frozenQty"></el-table-column>
        <el-table-column label="库存"
                         min-width="100"
                         prop="stockBalance"></el-table-column>
        <el-table-column label="创建时间"
                         width="150">
          <template slot-scope="{row}">{{ row.createdTime | dateformat()}}</template>
        </el-table-column>
        <el-table-column label="操作"
                         :key="1"
                         width="60">
          <template slot-scope="{row}">
            <el-button type="text"
                       @click="countinventory(row)">盘点</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page.sync="config.pageNum"
                       :page-size="config.pageSize"
                       layout="total, prev, pager, next"
                       :total="total">
        </el-pagination>
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import OwnerSelect from './owner-select.vue'
import Industry from '@/service/industry'
import { downloadBlobFile } from '@/utils/index'
// import ProductSelect from './product-select.vue'
export default {
  name: 'goods-storage',
  components: { OwnerSelect },
  data () {
    return {
      loading: false,
      config: { ownerRange: 1, pageNum: 1, pageSize: 10, productName: '', ownerId: null },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      query: state => state.common.query
    })
  },
  methods: {
    downloadinventorys () {
      this.loading = true
      Industry.downloadinventorys({ ...this.config })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    onTypeChange (ownerRange) {
      this.config = { ...this.config, ...this.$options.data().config, ownerRange }
      this.fetchList()
    },
    countinventory (row) {
      this.$prompt('请输入库存数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[1-9]\d*|0$/,
        inputErrorMessage: '请输入正确的库存数量(非负整数)',
        showClose: false,
        inputValue: '' + (row.frozenQty + row.stockBalance),
        closeOnClickModal: false,
        beforeClose: (action, instance, done) => {
          console.log(instance)
          if (action === 'cancel' || action === 'close') {
            done()
          } else {
            // this.loading = true
            instance.cancelButtonLoading = true
            instance.confirmButtonLoading = true
            const goodsQty = instance.inputValue
            this.$store.dispatch('stat/countinventory', {
              payload: { inventoryId: row.id, goodsQty },
              success: () => {
                // this.loading = false
                instance.cancelButtonLoading = false
                instance.confirmButtonLoading = false
                this.fetchList()
                this.$message.success('盘库成功')
                done()
              },
              fail: () => {
                // this.loading = false
                instance.cancelButtonLoading = false
                instance.confirmButtonLoading = false
              }
            })
          }
        }
      })
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('delivery/getinventorys', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    viewDetail (row) {
      console.log(row)
    },
    stockCount (row) {
      console.log(row)
    }
  },
  created () {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
<style lang="stylus"></style>
